import { Injectable } from '@angular/core';
import { ConditionalAccessPolicy } from '@microsoft/microsoft-graph-types-beta';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, distinct, last, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { retry } from 'projects/angular-clarity/src/app/pipes/retry.pipe';
import { TenantAjaxService } from 'projects/angular-clarity/src/app/services/ajax/tenant-ajax.service';

@Injectable()
export class AuthenticationStrengthPoliciesEffect {
    loadAuthenticationStrengthPolicies$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadAuthenticationStrengthPolicies),
            distinct((action) => action._tenant),
            mergeMap(({ _tenant }) =>
                this.ajax
                    .get<
                        Array<ConditionalAccessPolicy>
                    >(_tenant, '/api/microsoft/graph/policies/authenticationStrengthPolicies')
                    .pipe(
                        retry(5000, 4, 'authentication strength policies timeout'),
                        last(),
                        map((data: any) => {
                            return actions.loadAuthenticationStrengthPoliciesSuccess({ _tenant, polices: data.value });
                        }),
                        catchError((error) =>
                            of(actions.loadAuthenticationStrengthPoliciesFailure({ _tenant, error })),
                        ),
                    ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: TenantAjaxService,
    ) {}
}
